import React from 'react';
import { Loader, StackableCardDeck } from '@uplift/ui-v2';
import { EmptyActionItem } from '@uplift/pages';
import { useSeePsychiatristItem } from './psychiatrist';
import { useFormProgressActionItem } from './form-progress.item';
import { useBillingActionItem } from './billing.item';
import { useEmergencyContactActionItem } from './emergency-contact.item';
import { useOutstandingBalanceActionItem } from './outstanding-balance.item';
import { useMobileVerificationActionItem } from './mobile-verification.item';
import { Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useL10n } from '@uplift/hooks';
import { useSeeTherapistItem } from './see-therapist.item';
import { useVerifyEmailActionItem } from './verify-email';
import { useBetterhelpCoverageActionItem } from './betterhelp-coverage.item';

export const ActionItems: React.FC = () => {
  const { classes } = useStyles();
  const l10n = useL10n();

  const seePsychiatristActionItem = useSeePsychiatristItem();
  const outstandingBalanceActionItem = useOutstandingBalanceActionItem();
  const formProgressActionItem = useFormProgressActionItem();
  const billingActionItem = useBillingActionItem();
  const verifyEmailActionItem = useVerifyEmailActionItem();
  const emergencyContactActionItem = useEmergencyContactActionItem();
  const mobileVerificationActionItem = useMobileVerificationActionItem();
  const seeTherapistActionItem = useSeeTherapistItem();
  const betterhelpCoverageActionItem = useBetterhelpCoverageActionItem();

  const actionItems = [
    seePsychiatristActionItem,
    outstandingBalanceActionItem,
    formProgressActionItem,
    billingActionItem,
    verifyEmailActionItem,
    emergencyContactActionItem,
    mobileVerificationActionItem,
    seeTherapistActionItem,
    betterhelpCoverageActionItem,
  ];

  const isActionItemsLoading = actionItems.some(a => a.isLoading);

  if (isActionItemsLoading) {
    return (
      <Loader height="160px" />
    );
  }

  const allIsCompleted = !actionItems.some(a => a.actionItem);

  if (allIsCompleted) {
    return (
      <EmptyActionItem />
    );
  }

  const numItems = actionItems.map(x => x.actionItem).filter(x => x).reduce((acc, cur) => {
    if (Array.isArray(cur)) {
      return acc += cur.length;
    }

    return acc + 1;
  }, 0);

  const title = (
    <Typography variant="h3" className={classes.title}>
      {l10n.dashboard.toDo.numberOfItems(numItems)}&nbsp;
      <span className={classes.secondary}>{l10n.dashboard.toDo.toDo}</span>
    </Typography>
  );

  return (
    <React.Suspense fallback={<Loader height="160px" />}>
      {title}
      <StackableCardDeck>
        {seePsychiatristActionItem.actionItem}
        {seeTherapistActionItem.actionItem}
        {outstandingBalanceActionItem.actionItem}
        {billingActionItem.actionItem}
        {formProgressActionItem.actionItem}
        {verifyEmailActionItem.actionItem}
        {emergencyContactActionItem.actionItem}
        {mobileVerificationActionItem.actionItem}
        {betterhelpCoverageActionItem.actionItem}
      </StackableCardDeck>
    </React.Suspense>
  );
};

const useStyles = makeStyles()(theme => ({
  secondary: {
    color: theme.palette.secondary.main,
  },
  title: {
    marginLeft: theme.spacing(2),
    marginBottom: theme.spacing(3),
    [theme.breakpoints.up('md')]: {
      marginLeft: 0
    }
  }
}));
